export const DealerServiceBaseUrl = 'https://dealer-api.qa.dealer.warnerbros.com/'
export const DealerSharedServiceBaseUrl =  'https://shared-api.qa.dealer.warnerbros.com/';
export const OKTA_ISSUER_URL = "https://ssoqa.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_CLIENT_ID = "0oasmlcb2hqK7IXJc0h7";
export const OKTA_URL = "https://sso.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";